module.exports = __webpack_public_path__ + "img/1.2f88e5fd.png";